// src/services/nutritional-deficit.service.js//
import ApiService from "./api.service";
// import ApiMockService from './api.mock.service'

/**
 * * Nutritional Deficit
 *
 * getNutritionalDeficits --> Get List Nutritional deficit.
 *
 */
const DeficitNutritionalService = {
  getNutritionalDeficits: async function (params = {}, lang) {
    const response = await ApiService._get("api/nutritional-deficit", params, lang);
    return response.data;
  },
};

export default DeficitNutritionalService;
